// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"d294a668","359":"dfdab5a2","386":"b151552c","904":"c09df576","998":"da85323b"}[chunkId] + ".chunk.css";
};